import React from 'react';
import { Star, Sparkles } from 'lucide-react';
import { Avatar, AvatarImage, AvatarFallback } from './ui/avatar';
import { COSMIC_RANKS } from '../mock/mock';

export function RankBadge({ rank }) {
  const r = COSMIC_RANKS.find(x => x.rank === rank) || COSMIC_RANKS[0];
  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold" style={{ background: `${r.color}22`, color: r.color, border: `1px solid ${r.color}44` }}>
      <Star size={10} fill="currentColor" /> {r.name}
    </span>
  );
}

export function UserAvatar({ user, size = 40, ring = true, showAiLabel = true }) {
  const r = COSMIC_RANKS.find(x => x.rank === (user.rank || 1)) || COSMIC_RANKS[0];
  const isAi = !!(showAiLabel && user && user.avatar_is_ai && user.avatar);
  // Chip scales roughly with the avatar so it stays legible on 24-48 px avatars
  // without dominating them.
  const chipSize = size >= 56 ? 14 : size >= 40 ? 12 : 10;
  return (
    <div className="relative inline-block" style={{ width: size, height: size }}>
      <Avatar className="w-full h-full" style={{ boxShadow: ring ? `0 0 0 2px ${r.color}` : 'none' }}>
        <AvatarImage src={user.avatar} />
        <AvatarFallback className="bg-fuchsia-500/30">{(user.username || 'U').slice(0,2).toUpperCase()}</AvatarFallback>
      </Avatar>
      {isAi && (
        <span
          data-testid="user-avatar-ai-label"
          title="This avatar was generated by AI"
          className="absolute -bottom-0.5 -right-0.5 rounded-full bg-black/80 text-fuchsia-200 border border-fuchsia-400/60 flex items-center justify-center shadow"
          style={{ width: chipSize + 6, height: chipSize + 6 }}
        >
          <Sparkles size={chipSize} strokeWidth={2.5} />
        </span>
      )}
    </div>
  );
}
